import React from 'react';
import { 
  Home, 
  ClipboardList, 
  Luggage, 
  Bell,
  User,
  Building,
  Settings
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types/auth';
import styles from '../css/BottomTabBar.module.css';

interface BottomTabBarProps {
  selectedKey?: string;
  onTabChange?: (key: string) => void;
  userRole?: UserRole;
}

const BottomTabBar: React.FC<BottomTabBarProps> = ({ 
  selectedKey = 'dashboard',
  onTabChange,
  userRole: userRoleProp,
}) => {
  const { role: authRole } = useAuth();
  const userRole = userRoleProp ?? authRole;

  const baseTabs = [
    { key: 'dashboard', title: 'خانه', icon: <Home size={18} /> },
    { key: 'bookings', title: 'رزروها', icon: <ClipboardList size={18} /> },
    { key: 'trips', title: 'سفرها', icon: <Luggage size={18} /> },
    { key: 'notifications', title: 'اعلان‌ها', icon: <Bell size={18} /> },
  ];

  if (userRole === 'agency' || userRole === 'admin') {
    baseTabs.push({
      key: 'agency-dashboard',
      title: 'آژانس',
      icon: <Building size={18} />,
    });
  }

  if (userRole === 'admin') {
    baseTabs.push({
      key: 'admin-panel',
      title: 'مدیریت',
      icon: <Settings size={18} />,
    });
  }

  baseTabs.push({
    key: 'profile',
    title: 'حساب کاربری',
    icon: <User size={18} />,
  });

  return (
    <div className={styles.tabBar}>
      <div className={styles.tabList}>
        {baseTabs.map(item => (
          <div
            key={item.key}
            className={`${styles.tabItem} ${selectedKey === item.key ? styles.active : ''}`}
            onClick={() => onTabChange?.(item.key)}
          >
            <div className={styles.tabIcon}>
              {item.icon}
            </div>
            <div className={styles.tabLabel}>
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BottomTabBar;
